export default __webpack_public_path__ + "static/media/lamp.34ae8a3c.png";